import { Box, Button, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EyeIconWhite,EyeOpenIcon, EyeOffIconSvg, EyeOffWhiteIcon, WikiLogo } from "../assets/icons/icons";
import Cookies from "js-cookie";
import useEnterKeyPress from "../utils/useEnterKeyPress";
import { useGlobalContext } from "../App";
import { validate_if_not_empty } from "../utils/extensions";
import TextInput from "../shared/components/TextInput";
import { ImageContainer } from "../shared/components/ImageContainer";
import { loginUser } from "../services/authentication";
import { LoginCoverImg } from "../assets/images/image";
import DefaultLoading from "../shared/Loading/DefaultLoading";
import { HomeCoverBgHalf } from "../assets/images/image";
import UiWikiLogo from "../assets/icons/uiwikiLogo/UiWikiLogo";
// import EyeOpenIcon from "../assets/icons/eyeIconsSvg/EyeOpenIcon";
// import EyeOffIcon from "../assets/icons/eyeIconsSvg/EyeOffIcon";
// import { getLoginImages } from "../data/employeeData/EmployeeData";
const Login = () => {
  const navigate = useNavigate();

  const { setUserDetails } = useGlobalContext();

  // loading state
  const [showLoading, setShowLoading] = useState(false);
  const [isImagesLoading, setIsImagesLoading] = useState(false);

  // user details states
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");

  const [passwordVisible, setPasswordVisible] = useState(false);
  const signinButtonRef = useRef(null);

  // Error handling states
  const [error, setError] = useState<string>();

  // const coverImageList = [];

  const [randomImageUrl, setRandomImageUrl] = useState(null);

  const inputField1Ref = useRef(null);
  const inputField2Ref = useRef(null);

  const handleEnterKeyPress = () => {
    !showLoading && login();
  };

  // Use the custom hook
  useEnterKeyPress(handleEnterKeyPress);

  const getRandomImage = async () => {
    // setIsImagesLoading(true);
    // await getLoginImages("EMPLOYEE")
    //   .then((data: any) => {
    //     const imagesList = data[0]?.images;
    //     if (randomImageUrl === "" || !randomImageUrl) {
    //       setRandomImageUrl(
    //         imagesList[Math.floor(Math.random() * imagesList.length)]
    //       );
    //     }
    //     // if(imagesList?.length === 0) {
    //     //   setRandomImageUrl(coverImageList[randomIndex])
    //     // }
    //     setTimeout(() => {
    //       setIsImagesLoading(false);
    //     });
    //   })
    //   .catch((err) => {
    //     setIsImagesLoading(false);
    //   });
  };

  useEffect(() => {
    getRandomImage(); // Call this function to set a random image on component mount
  }, []);

  const validateFields = () => {
    if (
      validate_if_not_empty(loginId, "loginIdNotExist") &&
      validate_if_not_empty(password, "loginPassNotExist")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const login = async () => {
    setShowLoading(true);
    if (validateFields()) {
      try {
        setError("");

        const data = {
          username: loginId,
          password: password,
          adminCheck: true,
        };

        // Await the loginUser function call
        const res: any = await loginUser(data);
        if (
          res?.data?.token !== undefined &&
          res?.data?.token !== "" &&
          res?.data?.token !== null
        ) {
          localStorage.setItem("jstoken", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data));
          Cookies.set("jstoken", res.data.token);
          Cookies.set("user", JSON.stringify(res.data));
          Cookies.set("userId", JSON.stringify(res.data._id));

          setUserDetails(res?.data?.user);
          navigate("/");
        } else {
          switch (res?.response?.data?.message) {
            case "Failed to authenticate user":
              setError("Invalid Email or password! Please try again.");
              break;
            default:
              setError(res?.response?.data?.message);
              break;
          }
        }
      } catch (error: any) {
      } finally {
        setShowLoading(false);
      }
    } else {
      setShowLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "background.main",
        width: "100%",
        justifyContent: "center",
        maxWidth: "100%",
        minHeight: "100vh",
        height: "100%",
        paddingX: { xs: "24px", sm: "0px", lg: "0px" },
        pb: { xs: "24px", sm: "0px", lg: "0px" },
      }}
    >
      <img
        style={{
          position: "absolute",
          width: "100vw",
          height: "100vh",
          objectFit: "cover",
          zIndex: 1,
        }}
        alt="background"
        src={HomeCoverBgHalf}
      />
      <Box
        sx={{
          minHeight: { xs: "100vh", lg: "auto" },
          width: "100%",
          zIndex: 2,
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            height: "100vh",
          }}
        >
          {/* <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: { xs: "90%", md: "100%" },
            height: "100%",
            flex: 1,
          }}
        >
          {!isImagesLoading && (
            <img
              style={{
                aspectRatio: "720/679",
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              alt="signin cover"
              src={randomImageUrl ? randomImageUrl["url"] : LoginCoverImg}
            />
          )}
        </Box> */}

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              // flex: 1.5,
              height: "100vh",
              // bgcolor: "background.default",
              scrollbarWidth: "none",
              paddingTop: { xs: "60px", md: "80px" },
              paddingBottom: { xs: "40px", md: "80px" },
            }}
          >
            <Box
              sx={{
                maxWidth: { xs: "100%", sm: "426px", lg: "426px" },
                minHeight: { xs: "auto", sm: "625px", lg: "625px" },
                height: "auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
                margin: "auto",
                gap: { xs: "24px", sm: "24px", lg: "24px" },
                border: "1px solid #3D3D3D",
                boxSizing: "border-box",
                borderRadius: "24px",
                bgcolor: "#1B1B1B",
                p: { xs: "24px", sm: "40px", lg: "40px" },
              }}
            >
              <Box
                onClick={() => {
                  navigate("/");
                }}
                sx={{
                  width: "fit-content",
                  cursor: "pointer",
                }}
              >
                {/* <ImageContainer width={"80px"} height={"80px"} title="logo">
                  {WikiLogo}
                </ImageContainer> */}
                <UiWikiLogo />
              </Box>
              <Box
                sx={{
                  margin: "0",
                  padding: "0",
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  gap: { xs: "24px", sm: "24px", lg: "24px" },
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize:"24px",
                    fontWeight: "600",
                    color: "text.secondary",
                    lineHeight: "auto",
                  }}
                >
                  Sign in
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "12px",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      // gap: "24px",
                      gap: "16px",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        borderRadius: "14px",
                        // maxWidth: "480px",
                        m: "0px",
                        p: "0px",
                      }}
                    >
                      <TextInput
                        id="loginEmailInputField"
                        lableStyles={{
                          fontSize: "16px !important",
                          fontWeight: "600",
                          lineHeight: "auto",
                        }}
                        label="Email"
                        labelAstrickStyle={{ color: "#E25454" }}
                        placeholder="Enter Your Email/ Employee ID"
                        onChange={(e: any) => {
                          setLoginId(e.target.value);
                        }}
                        inputStyles={{
                          borderRadius: "14px",
                          color: "#FFFFFF",
                          height: "54px",
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          paddingLeft: "16px",
                        }}
                        textinputstyles={{
                          margin: "0px",
                          padding: "0px",
                          height: "auto",
                        }}
                        inputWrapStyle={{
                          minWidth: "10px !important",
                          width: "100%",
                        }}
                        onNext={inputField1Ref}
                        value={loginId}
                        required
                      />
                      <Typography
                        className="err_field"
                        id="loginIdNotExist"
                        color="red"
                        variant="body2"
                      ></Typography>
                    </Box>

                    <Box
                      borderRadius={12}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        borderRadius: "12px",
                        m: "0px",
                        p: "0px",
                      }}
                    >
                      <TextInput
                        id="loginPasswordInputField"
                        textinputstyles={{
                          margin: "0px",
                          padding: "0px",
                          height: "auto",
                        }}
                        lableStyles={{
                          fontSize: "16px !important",
                          fontWeight: "600",
                        }}
                        labelAstrickStyle={{ color: "#E25454" }}
                        label="Password"
                        placeholder="Enter your password"
                        icononclick={() => setPasswordVisible(!passwordVisible)}
                        icon={!passwordVisible ? EyeOpenIcon : EyeOffIconSvg}
                        type={!passwordVisible ? "password" : "text"}
                        onChange={(e: any) => {
                          setPassword(e.target.value);
                        }}
                        inputWrapStyle={{
                          minWidth: "10px !important",
                          width: "100%",
                        }}
                        inputStyles={{
                          borderRadius: "14px",
                          color: "#FFFFFF",
                          height: "54px",
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          paddingLeft: "16px",
                        }}
                        onNext={inputField2Ref}
                        value={password}
                        required
                        iconContainerStyles={{ right: "15px" }}
                        iconstyles={{ width: "24px", height: "24px" }}
                      />
                      <Typography
                        className="err_field"
                        id="loginPassNotExist"
                        color="red"
                        variant="body2"
                      ></Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "16px",
                      width: "100%",
                      justifyContent: "flex-end",
                      // maxWidth: "480px",
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        userSelect: "none",
                        color: "text.secondary",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "auto",
                      }}
                    >
                      Forgot password?
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "5px",
                    // maxWidth: "480px",
                    marginTop: "16px",
                  }}
                >
                  <Button
                    id="signinButton"
                    sx={{
                      width: "100%",
                      height: "54px",
                      textAlign: "center",
                      textTransform: "none",
                      bgcolor: "primary.main",
                      color: "#FFFFFF",
                      borderRadius: "14px",
                      paddingY: "17px",
                      "&:hover": {
                        backgroundColor: "primary.main",
                      },
                    }}
                    ref={signinButtonRef}
                    onClick={() => {
                      !showLoading && login();
                    }}
                    endIcon={
                      showLoading && (
                        <Box
                          sx={{
                            width: "42px",
                            height: "42px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <DefaultLoading />
                        </Box>
                        // <CircularProgress
                        //   size={20}
                        //   sx={{
                        //     color: "white",
                        //     marginRight: "12px",
                        //   }}
                        // />
                      )
                    }
                  >
                    <Typography
                      sx={{
                        color: "text.primary",
                        fontSize: "16px !important",
                        fontWeight: "600",
                        lineHeight: "auto",
                      }}
                    >
                      {!showLoading && "Sign in"}
                    </Typography>
                  </Button>
                  {error && (
                    <Typography
                      sx={{ width: "100%" }}
                      fontWeight={"400"}
                      variant="caption"
                      color="#E03137"
                    >
                      {error}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
